import axios from 'axios';

// Get the API URL from environment variables or use default (without /api prefix)
let apiUrl = process.env.REACT_APP_API_URL || '/api';

// Remove duplicate /api if it exists at the end of the URL
if (apiUrl.endsWith('/api')) {
  apiUrl = apiUrl.slice(0, -4); // Remove trailing /api
}

// Configure axios base URL
axios.defaults.baseURL = apiUrl;

// Create specialized API instance that automatically adds /api prefix
const api = {
  get: (url, config) => axios.get(ensureApiPrefix(url), config),
  post: (url, data, config) => axios.post(ensureApiPrefix(url), data, config),
  put: (url, data, config) => axios.put(ensureApiPrefix(url), data, config),
  delete: (url, config) => axios.delete(ensureApiPrefix(url), config),
  patch: (url, data, config) => axios.patch(ensureApiPrefix(url), data, config)
};

// Helper function to ensure URL has /api prefix
function ensureApiPrefix(url) {
  if (!url.startsWith('/api')) {
    return `/api${url}`;
  }
  return url;
}

// Set up console debugging
function setupInterceptors(instance) {
  // Add request interceptor
  instance.interceptors.request.use(
    config => {
      // console.log(`[axios] Request: ${config.method?.toUpperCase()} ${config.url}`, config);
      return config;
    },
    error => {
      console.error('[axios] Request Error:', error);
      return Promise.reject(error);
    }
  );

  // Add response interceptor
  instance.interceptors.response.use(
    response => {
      // console.log(`[axios] Response: ${response.status} for ${response.config.url}`);
      return response;
    },
    error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error(`[axios] Response Error: ${error.response.status}`, {
          data: error.response.data,
          headers: error.response.headers,
          url: error.config.url
        });
      } else if (error.request) {
        // The request was made but no response was received
        console.error('[axios] No Response Error:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('[axios] Error:', error.message);
      }
      return Promise.reject(error);
    }
  );
}

// Setup interceptors for axios
setupInterceptors(axios);

// In development mode, use a mock token that matches the server's MOCK_DEV_TOKEN
// Otherwise check for existing token in localStorage
const mockToken = 'mock_jwt_token_for_development';
const token = process.env.NODE_ENV === 'development' 
  ? mockToken 
  : localStorage.getItem('token');

// Set the auth header with the appropriate token
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export { axios, api };
export default api; 